export default "__VITE_ASSET__BCZiOurK__"